if ($('html').hasClass('ie9')) {
	$('input, textarea').placeholder();
}



// WEBPACK FOOTER //
// ./_dev/blocks/placeholder/placeholder.js